module.exports = __webpack_public_path__ + "img/font.b8546fd2.png";